<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .label-text {
    padding: 0 utils.in_rem(4px) utils.in_rem(4px) utils.in_rem(4px);
    @include mixins.body3();
  }
</style>

<script>
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import { derived } from "svelte/store";
  import { currenciesStore } from "../../../../../../api-stores/currencies-store";
  import { editContactStore } from "../../../stores";

  const currencyItems = derived(currenciesStore, ($currenciesStore) => {
    const currencies = $currenciesStore?.currencies || [];
    return [
      { id: "", label: "None", description: "No currency selected" },
      ...currencies.map((currency) => ({
        id: currency.code,
        label: currency.code,
        description: currency.name,
      })),
    ];
  });

  currenciesStore.once();
</script>

<SingleSelectDropdown
  items={$currencyItems}
  bind:selected={$editContactStore["salaryCurrency"]}
  showDescription
  showFilter
  style="box-sizing: content-box; width: calc(100% - 26px);"
>
  {#snippet labelSnippet()}
    <span class="label-text">Currency</span>
  {/snippet}
</SingleSelectDropdown>
